// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.certificate-manage-wrap {
    /* min-height: 100vh; */
    background: #fff;
}

.certificate-manage-header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 60px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    border-bottom: 1px solid #e5e5e5;
    z-index: 1000;
}

.certificate-manage-back-btn {
    background: transparent;
    border: none;
    font-size: 20px;
    cursor: pointer;
    color: #333;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
}

.certificate-manage-title {
    font-size: 18px;
    font-weight: 600;
    color: #111;
    margin: 0;
    flex: 1 1;
    text-align: center;
}

.certificate-manage-content {
    margin-top: 60px;
    padding: 20px;
}

.certificate-section {
    margin-bottom: 30px;
}

/* 신청한 자격증 섹션에만 스크롤 적용 */
.certificate-certificates-section {
    display: flex;
    flex-direction: column;
}

.certificate-list-container {
    max-height: calc(100vh - 280px);
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 4px;
    -webkit-overflow-scrolling: touch;
}

/* 스크롤바 스타일링 */
.certificate-list-container::-webkit-scrollbar {
    width: 6px;
}

.certificate-list-container::-webkit-scrollbar-track {
    background: #f5f5f5;
    border-radius: 3px;
}

.certificate-list-container::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 3px;
}

.certificate-list-container::-webkit-scrollbar-thumb:hover {
    background: #999;
}

.certificate-section-title {
    font-size: 16px;
    font-weight: 600;
    color: #111;
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 1px solid #ddd;
}

.certificate-item {
    background: #f8f8f8;
    border-radius: 12px;
    padding: 12px 16px;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid #e5e5e5;
}

.certificate-item-info {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1 1;
}

.certificate-item-number {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #4285f4;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 600;
    flex-shrink: 0;
}

.certificate-item-details {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1 1;
}

.certificate-item-name {
    font-size: 16px;
    font-weight: 500;
    color: #111;
}

.certificate-item-status {
    font-size: 12px;
    color: #666;
}

.certificate-item-actions {
    display: flex;
    align-items: center;
    gap: 12px;
}

.certificate-toggle-btn {
    background: transparent;
    border: none;
    font-size: 18px;
    cursor: pointer;
    color: #666;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 8px;
    transition: background 0.2s;
}

.certificate-toggle-btn:hover {
    background: #f0f0f0;
}

.certificate-toggle-btn:active {
    background: #e0e0e0;
}

.certificate-hamburger-btn {
    background: transparent;
    border: none;
    font-size: 18px;
    cursor: grab;
    color: #999;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 8px;
    transition: all 0.2s;
    touch-action: none;
}

.certificate-hamburger-btn:hover {
    background: #f0f0f0;
    color: #666;
}

.certificate-hamburger-btn:active {
    cursor: grabbing;
    background: #e0e0e0;
}

.certificate-item {
    transition: transform 0.2s, opacity 0.2s;
}

.certificate-empty {
    text-align: center;
    padding: 40px 20px;
    color: #999;
    font-size: 14px;
    background: #f8f8f8;
    border-radius: 12px;
    border: 1px solid #e5e5e5;
}

`, "",{"version":3,"sources":["webpack://./src/Pages/css/certificate-manage.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,gCAAgC;IAChC,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,SAAS;IACT,SAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,+BAA+B;IAC/B,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA,cAAc;AACd;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,SAAO;AACX;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,SAAO;AACX;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;AAC7B","sourcesContent":[".certificate-manage-wrap {\r\n    /* min-height: 100vh; */\r\n    background: #fff;\r\n}\r\n\r\n.certificate-manage-header {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    height: 60px;\r\n    background: #fff;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 0 10px;\r\n    border-bottom: 1px solid #e5e5e5;\r\n    z-index: 1000;\r\n}\r\n\r\n.certificate-manage-back-btn {\r\n    background: transparent;\r\n    border: none;\r\n    font-size: 20px;\r\n    cursor: pointer;\r\n    color: #333;\r\n    padding: 8px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 40px;\r\n    height: 40px;\r\n}\r\n\r\n.certificate-manage-title {\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n    color: #111;\r\n    margin: 0;\r\n    flex: 1;\r\n    text-align: center;\r\n}\r\n\r\n.certificate-manage-content {\r\n    margin-top: 60px;\r\n    padding: 20px;\r\n}\r\n\r\n.certificate-section {\r\n    margin-bottom: 30px;\r\n}\r\n\r\n/* 신청한 자격증 섹션에만 스크롤 적용 */\r\n.certificate-certificates-section {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.certificate-list-container {\r\n    max-height: calc(100vh - 280px);\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n    padding-right: 4px;\r\n    -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n/* 스크롤바 스타일링 */\r\n.certificate-list-container::-webkit-scrollbar {\r\n    width: 6px;\r\n}\r\n\r\n.certificate-list-container::-webkit-scrollbar-track {\r\n    background: #f5f5f5;\r\n    border-radius: 3px;\r\n}\r\n\r\n.certificate-list-container::-webkit-scrollbar-thumb {\r\n    background: #ccc;\r\n    border-radius: 3px;\r\n}\r\n\r\n.certificate-list-container::-webkit-scrollbar-thumb:hover {\r\n    background: #999;\r\n}\r\n\r\n.certificate-section-title {\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    color: #111;\r\n    margin-bottom: 12px;\r\n    padding-bottom: 8px;\r\n    border-bottom: 1px solid #ddd;\r\n}\r\n\r\n.certificate-item {\r\n    background: #f8f8f8;\r\n    border-radius: 12px;\r\n    padding: 12px 16px;\r\n    margin-bottom: 12px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    border: 1px solid #e5e5e5;\r\n}\r\n\r\n.certificate-item-info {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 12px;\r\n    flex: 1;\r\n}\r\n\r\n.certificate-item-number {\r\n    width: 32px;\r\n    height: 32px;\r\n    border-radius: 50%;\r\n    background: #4285f4;\r\n    color: #fff;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.certificate-item-details {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 4px;\r\n    flex: 1;\r\n}\r\n\r\n.certificate-item-name {\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n    color: #111;\r\n}\r\n\r\n.certificate-item-status {\r\n    font-size: 12px;\r\n    color: #666;\r\n}\r\n\r\n.certificate-item-actions {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 12px;\r\n}\r\n\r\n.certificate-toggle-btn {\r\n    background: transparent;\r\n    border: none;\r\n    font-size: 18px;\r\n    cursor: pointer;\r\n    color: #666;\r\n    padding: 8px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 36px;\r\n    height: 36px;\r\n    border-radius: 8px;\r\n    transition: background 0.2s;\r\n}\r\n\r\n.certificate-toggle-btn:hover {\r\n    background: #f0f0f0;\r\n}\r\n\r\n.certificate-toggle-btn:active {\r\n    background: #e0e0e0;\r\n}\r\n\r\n.certificate-hamburger-btn {\r\n    background: transparent;\r\n    border: none;\r\n    font-size: 18px;\r\n    cursor: grab;\r\n    color: #999;\r\n    padding: 8px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 40px;\r\n    height: 40px;\r\n    border-radius: 8px;\r\n    transition: all 0.2s;\r\n    touch-action: none;\r\n}\r\n\r\n.certificate-hamburger-btn:hover {\r\n    background: #f0f0f0;\r\n    color: #666;\r\n}\r\n\r\n.certificate-hamburger-btn:active {\r\n    cursor: grabbing;\r\n    background: #e0e0e0;\r\n}\r\n\r\n.certificate-item {\r\n    transition: transform 0.2s, opacity 0.2s;\r\n}\r\n\r\n.certificate-empty {\r\n    text-align: center;\r\n    padding: 40px 20px;\r\n    color: #999;\r\n    font-size: 14px;\r\n    background: #f8f8f8;\r\n    border-radius: 12px;\r\n    border: 1px solid #e5e5e5;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
